// extracted by mini-css-extract-plugin
export default {"wrapper":"TourBadge_wrapper__Rlsb8","dark":"TourBadge_dark__GU+eG"};